<template id="roleForm">    
    <div v-if="order.id">                
        <div class="row">
            <div class="col-md-10">
                <h3>Order {{order.id}}</h3>
            </div>
        </div>
        
        <div class="row mt-4">
            <div class="col-md-6">
                <h5>ข้อมูลทั่วไป</h5>
                <div class="text text-secondary">
                    <div>
                        สั่งเมื่อ {{order.created_at_x.ymd_his}}  ({{order.created_at_x.time_ago}})
                    </div>
                    <div>
                        erp Id {{order.erp_order_id}}
                    </div>
                    <div>
                        device {{order.user_device}}
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <h5>ลูกค้า</h5>
                <div class="text text-secondary">
                    <div>
                        <i aria-hidden="true" class="fa fa-user"></i> <span >{{order.customer.first_name}} {{order.customer.last_name}} </span> 
                    </div>
                    <div>
                        <i aria-hidden="true" class="fa fa-phone"></i> <span >{{order.customer.phone_number}} </span> 
                    </div>
                    <div>
                        <i aria-hidden="true" class="fa fa-at"></i> <span >{{order.customer.email_address}} </span> 
                    </div>
                </div>
            </div>                
        </div>
        <div class="row mt-4">
            <div class="col-md-12">
                <h5>สินค้า</h5>
                <div class="row text text-secondary" v-for="product in order.products" v-bind:key="'product_'+product.id">
                    <div class="col-md-2">
                        <!-- <img class="img-thumbnail" style="width:100%" v-bind:src="'https://picsum.photos/200/200?random='+product.id" v-bind:alt="'ภาพสินค้า '+ product.product_name"> -->
                        <img class="img-thumbnail" style="width:100%" v-bind:src="products[product.product_id].imgs.main" v-bind:alt="'ภาพสินค้า '+ product.product_name">
                    </div>
                    <div class="col-md-2">
                        <div class="row">
                            <div class="col-md-12 m-0">
                                {{product.product_name}}
                            </div>
                            <div class="col-md-12 m-0">
                                {{parseInt(product.price_per_unit).toLocaleString()}} x {{product.quantity}}
                            </div>
                            <div class="col-md-12 m-0">
                                {{parseInt(product.total_price).toLocaleString()}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <h6>ข้อความ:</h6>
                        <div class="row border-top">
                            <div class="col-md-5">บรรทัดแรก</div><div class="col-md-5">บรรทัดที่สอง</div><div class="col-md-2">บรรทัดที่สาม+สี่</div>
                        </div>
                        <div class="row" v-for="msg in order.message_on_items" v-bind:key="'mgg_'+msg.id">
                            <div class="col-md-12" v-if="product.product_id==msg.product_id">
                                <div class="row border-top">
                                    <div class="col-md-5">{{msg.message_on_1st_line}}</div>
                                    <div class="col-md-5">{{msg.message_on_2nd_line}}</div>
                                    <div class="col-md-2">{{msg.message_on_3rd_line}} {{msg.message_on_4th_line}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-md-4">
                <h5>การจัดส่ง (Delivery)</h5>
                <div class="text text-secondary">            
                    <div>
                        <i aria-hidden="true" class="fa fa-ship"></i> <span >{{order.delivery.recipient_name}}</span> 
                    </div>
                    <div>
                        <i aria-hidden="true" class="fa fa-phone"></i> <span >{{order.delivery.recipient_phone_number}}</span> 
                    </div>
                    <div>
                        <i aria-hidden="true" class="fa fa-map-marker"></i> <span >{{order.delivery.delivery_location}} {{order.delivery.delivery_address}}</span>
                    </div>
                    <div>
                        <i aria-hidden="true" class="fa fa-calendar"></i> <span >{{order.delivery.delivery_date}}</span>
                        <span >{{order.delivery.delivery_time}} </span>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <h5>การชำระ</h5>
                <div class="row text text-secondary">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-4">ช่องทาง</div>
                            <div class="col-md-5"><div class="float-right">{{order.payment.payment_method_id}}</div></div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">สถานะ</div>
                            <div class="col-md-5"><div class="float-right">{{order.payment.status_id}}</div></div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">ค่าสินค้า</div>
                            <div class="col-md-5"><div class="float-right">{{parseInt(order.payment.subtotal).toLocaleString()}}</div></div>
                            <div class="col-md-3">บาท</div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">ส่วนลด</div>
                            <div class="col-md-5"><div class="float-right">{{parseInt(order.payment.discount).toLocaleString()}}</div></div>
                            <div class="col-md-3">บาท</div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">ค่าส่ง</div>
                            <div class="col-md-5"><div class="float-right">{{parseInt(order.payment.shipping_cost).toLocaleString()}}</div></div>
                            <div class="col-md-3">บาท</div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">ภาษี</div>
                            <div class="col-md-5"><div class="float-right">{{parseInt(order.payment.tax).toLocaleString()}}</div></div>
                            <div class="col-md-3">บาท</div>
                        </div>
                        <div class="row font-weight-bold border-top border-bottom">
                            <div class="col-md-4 text">รวม</div>
                            <div class="col-md-5"><div class="float-right">{{parseInt(order.payment.total).toLocaleString()}}</div></div>
                            <div class="col-md-3">บาท</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <h5>บิลเงินสด/ใบกำกับภาษี</h5>
                <div class="row text text-secondary" v-for="receipt in order.receipt" v-bind:key="'receipt_'+receipt.id">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-4">ชนิด</div>
                            <div class="col-md-8"><div>{{receipt.receipt_type_id}}</div></div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">ออกให้</div>
                            <div class="col-md-8"><div>{{receipt.recipient}}</div></div>
                        </div>
                        <div class="row" v-if="receipt.recipient_branch">
                            <div class="col-md-4">สาขา</div>
                            <div class="col-md-8"><div>{{receipt.recipient_branch}}</div></div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">ที่อยู่</div>
                            <div class="col-md-8"><div>{{receipt.recipient_address}}</div></div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">เลขประจำตัวผู้เสียภาษี</div>
                            <div class="col-md-8"><div>{{receipt.tax_id}}</div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 pt-5">
                <div class="form-group float-right">
                    <a v-bind:href="base_url" class="btn btn-secondary">กลับ</a>
                    <!-- <button type="button" class="btn btn-primary ml-5" @click="saveWithGoBack()">บันทึก</button> -->
                    <!-- <button type="button" v-if="!this.item_id" class="btn btn-primary ml-5" @click="saveWithMore()">บันทึก และ บันทึกเพิ่ม</button> -->
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
    export default {
        props:{
            item_id:'', //เก็บ id ของ role กรณีที่เป็นการแก้ไข
        },
        components: {                
        },        
        data() {
            return {                
                // form:{
                //     title:'',
                //     desc:'',
                //     permissions:[],                    
                // },                
                order:{}, 
                products:{},
                // validateError:{ 
                //     // เก็บตัวแปรผลการ submit form ว่ามีฟิลด์ไหน error บ้าง ซึ่งจะ bind กับ ตัวแปรใน <form-error> ให้เลือกเฉพาะฟิลด์ที่ต้อง validate สามารถดูว่าฟิลด์ไหน validate หรือไม่ให้ดูได้ที่ app-backend/app/controller/controller นั้นๆ
                //     title:{error:false,message:''},
                //     desc:{error:false,message:''},
                //     permissions:{error:false,message:''},                    
                // },
                permissions:{},
                base_url:'/order', // base url (เปลี่ยน)                
            }
        },
        mounted() {
            this.load();
        },
        created(){            
            
        },
        methods:{
            load(){
                console.log(this.item_id);
                axios.get(this.base_url+'/'+this.item_id)
                .then(response => {
                    // console.log(response.data.role[0]);
                    this.order = response.data.order;
                    this.products = response.data.products;
                }).catch(errors => {
                    alert('loading order error', errors)
                    console.log(errors);
                });
            },
            // saveWithGoBack(){
            //     this.save('');
            // },            
            // saveWithMore(){
            //     this.save('more');                
            // },
            // save(whatNext){
            //     let save_url = '';
            //     if(this.item_id!=''){
            //         save_url = this.base_url+'/'+this.item_id+'/update';
            //     }else{
            //         save_url = this.base_url;
            //     }

            //     let me = this;
            //     //console.log(this.form); 

            //     //เคลียร์ error ก่อนหน้า
            //     let fields = Object.keys(this.form);
            //     fields.forEach(function(item){
            //         me.validateError[item].error = false;
                    
            //     });             
                
            //     console.log(this.form); //return;
            //     axios.post(save_url,this.form)
            //     .then(response => {
            //         console.log(response);                    
            //         if(whatNext=='more'){
            //             // reload form
            //             window.location.href = this.base_url+'/form';
            //         }else{
            //             // go back
            //             window.location.href = this.base_url;
            //         }
            //     }).catch(errors => {
            //         if(errors.response.data.message){
            //             let errorMessage = errors.response.data.message;                                               
            //             let fields = Object.keys(this.form);
            //             fields.forEach(function(item){
            //                 // console.log(item);
            //                 if(typeof errorMessage[item] !='undefined'){
            //                     me.validateError[item].error = true;
            //                     me.validateError[item].message = errorMessage[item][0];
            //                 }
            //             });

            //         }else{
            //             console.log(errors.response.data._infos.result);
            //             alert('ไม่สามารถบันทึกได้ '+ errors.response.data);
            //         }
            //     })
            //     ;
            // },
            // fetchPermissions(url){
            //     url = url || '/permission/list';
            //     axios.get(url).then(response => {
            //         this.permissions = response.data.items;                                            
            //         // this.onRoleChanged(this.form.role_id);
            //         let items = Object.entries(this.permissions);
            //         console.log(items);
            //         let me = this;
            //         items.forEach(function(item,idx){
            //             me.form.permissions[item[1].id] = {checked:false}
            //         });

            //         if(this.item_id){
            //             this.load();
            //         }
            //     })
            //     .catch(errors => {
            //         console.log(errors);
            //     });
            // },
        },
    }
</script>